import actionTypes from '../../action-types'

export default () => ({
  type: actionTypes.WEB_AUTH_N.START_LOGIN,
})
